export const createExportWorker = (): Worker | null => {
  try {
    return new Worker(
      new URL('./serializeExportContent.worker.ts', import.meta.url),
      { type: 'module' }
    );
  } catch (error) {
    console.warn(
      'Export worker unavailable, falling back to main thread',
      error
    );
    return null;
  }
};
